import styled from 'styled-components';

export const RpmBox = styled.div`
  display: flex;
  border-radius: 14px;
  cursor: pointer;
  overflow: hidden;
  min-height: 87px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  .left-content {
    width: 32%;
    display: flex;
    align-items: center;
    margin-right: 10px;
    position: relative;
    padding-right: 30px;
    .img-container {
      margin-right: 10px;
      width: 67px;
      .patient-img {
        margin-left: -15px;
        width: 82px;
        height: 82px;
        border-radius: 50%;
        object-fit: cover;
        margin-bottom: -20px;
      }
    }

    .patient-info {
      overflow: hidden;

      &__note {
        /* width: 70%; */
        color: #707582;
        text-align: center;
        font-family: 'Nunito Sans';
        font-size: 13px;
        text-align: start;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* Número de líneas visibles */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &__name {
        /* width: 70%; */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #707582;
        font-family: 'Nunito Sans';
        font-size: 17px;
      }
    }

    &::after {
      content: '';
      width: 1px;
      height: 60%;
      background-color: #e2dedf;
      position: absolute;
      right: 12px;
    }
  }

  .center-content {
    width: 32%;
    display: flex;
    align-items: center;
    position: relative;
    padding-right: 30px;
    box-sizing: border-box;
    padding: 10px 0;
    .devices {
      width: 100%;
      &__label {
        font-size: 13px;
        font-weight: 400;
        margin-top: 10px;
        color: #3E3E5B;
      }

      &__count {
        margin: 0 10px;
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 400;
        color: #3E3E5B;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &-icon {
          font-size: 13px;
          margin-right: 6px;
        }
      }
    }

    &::after {
      content: '';
      width: 1px;
      height: 60%;
      background-color: #e2dedf;
      position: absolute;
      right: 30px;
    }
  }

  .right-content {
    width: 33%;
    display: flex;
    border-radius: 14px;
    background: ${({ color }) => color};
    padding: 10px;
    transition: background-color 0.8s;
    
    .calls {
      width: 100%;
      .labels {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #1F1F52;
        &__text {
          display: flex;
          align-items: center;
          margin-left: 10px;
          &-icon {
            font-size: 11px;
            margin-right: 5px;
            color: #707582;
          }
        }
      }
      .bar {
        display: flex;
        position: relative;
        align-items: center;
        margin-top: 10px;
        width: 100%;
        height: 33px;
        background-color: #B7C1FF;
        border-radius: 100px;
        &__content {
          height: 100%;
          background: linear-gradient(90deg, #798CFF 0%, #9B69FF 100%);
          border-radius: 100px;
        }
        &__labels {
          display: flex;
          justify-content: space-between;
          width: 100%;
          position: absolute;
          padding: 0 20px;
          box-sizing: border-box;
          color: #FFFFFF;
        }
      }
    }
    
  }
`;
